/* ===== EN Cart Scroll-Hint =====
   Beim Öffnen des Warenkorb-Drawers mit MEHR ALS EINEM Artikel:
   ein kurzer, smoother "Peek" — einmal ein Stück runterscrollen und wieder hoch.
   Signalisiert dem Kunden, dass unten noch mehr im Warenkorb liegt.

   - Nur wenn > 1 Artikel UND der Body wirklich überläuft (sonst nichts zu zeigen)
   - Startet erst, wenn der Drawer fertig eingeschoben ist (transitionend / Fallback)
   - Eigener requestAnimationFrame-Tween (easeInOutQuad) → gleiches, schnelles Timing in ALLEN Browsern
   - Ältere Browser ohne rAF: kein Animations-Ruckeln, degradiert lautlos (Warenkorb bleibt voll nutzbar)
   - Respektiert prefers-reduced-motion; bricht ab, sobald der Nutzer selbst scrollt/tippt
*/
(function () {
  if (window.__enScrollHintInit) return;
  window.__enScrollHintInit = 1;

  var VELO = 2.6;        // ms pro px → konstante, angenehme Geschwindigkeit (die gelobte)
  var HOLD_MS = 150;     // kurze Pause unten
  var MIN_OVERFLOW = 24; // darunter lohnt sich der Hint nicht

  function reduceMotion() {
    try { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (e) { return false; }
  }

  function easeInOutQuad(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

  // Einfacher, abbrechbarer Scroll-Tween. Gibt ein Objekt mit .cancel() zurück.
  function tween(el, to, duration, done) {
    var handle = { cancelled: false, cancel: function () { this.cancelled = true; } };
    var start = el.scrollTop, delta = to - start;
    if (delta === 0) { if (done) done(); return handle; }
    if (!window.requestAnimationFrame) { el.scrollTop = to; if (done) done(); return handle; }
    var t0 = null;
    function step(ts) {
      if (handle.cancelled) return;
      if (t0 === null) t0 = ts;
      var p = (ts - t0) / duration; if (p > 1) p = 1;
      el.scrollTop = start + delta * easeInOutQuad(p);
      if (p < 1) window.requestAnimationFrame(step);
      else if (done) done();
    }
    window.requestAnimationFrame(step);
    return handle;
  }

  function runHint(drawer) {
    if (reduceMotion()) return;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var items = drawer.querySelectorAll('.cart-item');
    // Mobile: schon ab 1 Artikel wichtig (Upsell zeigen → 2. Kauf anstoßen). Desktop: ab 2.
    if (items.length < (isMobile ? 1 : 2)) return;
    var body = drawer.querySelector('#CartDrawer-Body');
    if (!body) return;

    var startWhenReady = function () {
      var maxScroll = body.scrollHeight - body.clientHeight;
      if (maxScroll < MIN_OVERFLOW) return;          // nichts zu enthüllen

      var target;
      if (isMobile) {
        // Mobile: runter Richtung Upsell (liegt im Scroll-Fluss unter den Artikeln),
        // ABER höchstens 2,5 Artikel weit. Wer schon viel im Korb hat, wird nicht genervt —
        // der kauft eh kaum noch nach. Kleiner Korb → maxScroll gewinnt → Upsell wird gezeigt.
        var lis = drawer.querySelectorAll('.cart-item');
        var stride = 0;
        if (lis.length >= 2) stride = lis[1].getBoundingClientRect().top - lis[0].getBoundingClientRect().top;
        if (stride < 20) stride = (lis[0] ? lis[0].getBoundingClientRect().height : 0) || Math.round(body.clientHeight * 0.5);
        target = Math.min(maxScroll, Math.round(stride * 2.5));
      } else {
        // Desktop: kurzer Peek — der Upsell ist hier ein seitliches Flyout, kein Runterscrollen nötig.
        target = Math.round(body.clientHeight * 0.5);
        if (target < 130) target = 130;
        if (target > 220) target = 220;
        if (target > maxScroll) target = maxScroll;
      }
      if (target < MIN_OVERFLOW) return;

      // Dauer aus Distanz → gleiche, gelobte Geschwindigkeit; gedeckelt, damit's schnell bleibt
      var downDur = Math.min(700, Math.max(300, Math.round(target * VELO)));
      var upDur = downDur;

      var active = null, cancelled = false;
      function stop() {
        cancelled = true;
        if (active) active.cancel();
        detach();
      }
      function detach() {
        body.removeEventListener('wheel', stop);
        body.removeEventListener('touchstart', stop);
        body.removeEventListener('keydown', stop);
      }
      // Sobald der Nutzer selbst übernimmt → sofort abbrechen (nicht gegen ihn arbeiten)
      body.addEventListener('wheel', stop, { passive: true });
      body.addEventListener('touchstart', stop, { passive: true });
      body.addEventListener('keydown', stop);

      active = tween(body, target, downDur, function () {
        if (cancelled) return;
        setTimeout(function () {
          if (cancelled) return;
          active = tween(body, 0, upDur, detach);
        }, HOLD_MS);
      });
    };

    // Erst starten, wenn der Drawer fertig eingeschoben ist
    var inner = drawer.querySelector('.cart-drawer__inner');
    var started = false;
    var go = function () { if (started) return; started = true; startWhenReady(); };
    if (inner && inner.addEventListener) {
      var onEnd = function (e) {
        if (e && e.propertyName && e.propertyName !== 'transform') return;
        inner.removeEventListener('transitionend', onEnd);
        go();
      };
      inner.addEventListener('transitionend', onEnd);
    }
    setTimeout(go, 620);   // Fallback, falls transitionend nicht feuert
  }

  function boot() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    var wasVisible = drawer.classList.contains('is-visible');
    var obs = new MutationObserver(function () {
      var now = drawer.classList.contains('is-visible');
      if (now && !wasVisible) runHint(drawer);       // nur beim Öffnen (Übergang zu sichtbar)
      wasVisible = now;
    });
    obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
